import BaseComponent from "../../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";

class ChangelogEntry extends BaseComponent {

  render() {
    return <div className="flex gap-3 p-2 rounded-lg hover:bg-white/5 transition">
      <div className="min-w-2 h-2 mt-1 rounded-sm bg-cn-color-primary shadow-indigo-500/50 shadow"></div>
      <div>
        <div className="font-medium text-sm">{this.props.title}</div>
        <div className="text-xs text-white">{this.props.description}</div>
      </div>
    </div>
  }
}

ChangelogEntry.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}
export default ChangelogEntry;
